<h2 mat-dialog-title>ATENCION</h2>
<mat-dialog-content class="mat-typography">
  <div fxLayout="column" fxLayoutAlign="center center">
    <h4>Deseas utilizar nubby para facturacion?</h4>
    <div fxLayout="row" fxLayoutGap="20px">
      <button mat-raised-button color="warn" (click)="no()">No</button>
      <button mat-raised-button color="accent" (click)="si()">Si</button>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end"> </mat-dialog-actions>
